import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  Output,
  EventEmitter,
} from "@angular/core";
import {
  IFilterComponent,
  SearchFilter,
} from "src/app/infrastructure/iFilter-component";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { FilterRecordService } from "src/app/services/filter-record.service";
import { FilterService } from "src/app/services/filter.service";
import { BillingCloseService } from "../../../services/billing/billing-close.service";
import { Plan } from "../../../model/entity/plan";
import { Entity } from "../../../model/entity/entity";
import { AliquotTax } from "../../../model/aliquot-tax";
import { ServiceFilter } from "../../../model/service-filter";
import { BillingStateFilter } from "../../../model/billing/billing-state-filter";
import { EntityService } from "../../../services/entity.service";
import { MatOption } from "@angular/material";
import { AuthService } from "../../../services/auth.service";
import { TaxType } from "src/app/enums/tax-type.enum";
import { NoBillingReasonFilter } from "../../../model/billing/no-billing-reason-filter";
import { Center } from "src/app/model/center";
import { CenterFilter } from "src/app/model/center-filter";
import { EquipmentFilter } from "src/app/model/equipment-filter";
import { SpecialityFilter } from "src/app/model/speciality-filter";
import { PracticeFilter } from "src/app/model/practice/practice-filter";
import { FilterCompleteService } from "src/app/filter-complete/filter-complete";
import { PatientSearch } from "src/app/model/patient";

@Component({
  selector: "app-billing-close-filter",
  templateUrl: "./billing-close-filter.component.html",
  styleUrls: ["./billing-close-filter.component.css"],
})
export class BillingCloseFilterComponent implements IFilterComponent, OnInit {
  form: FormGroup;
  @ViewChild("formElement", { static: false }) formElement: ElementRef;
  @ViewChild("allEntitySelected", { static: false })
  private allEntitySelected: MatOption;

  branchs: CenterFilter[] = [];
  entities: Entity[] = [];
  plans: Plan[] = [];
  aliquotTaxs: AliquotTax[] = [];
  services: ServiceFilter[] = [];
  equipments: EquipmentFilter[] = [];
  specialities: SpecialityFilter[] = [];
  filterCompletePractices: FilterCompleteService<PracticeFilter>;
  billingStates: BillingStateFilter[] = [];
  noBillingReasons: NoBillingReasonFilter[] = [];

  entitiesDerivantes: Entity[] = [];
  entitiesNoDerivantes: Entity[] = [];

  orderByPatient: boolean;

  // tslint:disable-next-line: no-output-on-prefix
  @Output() onInitSearch = new EventEmitter();
  @Output() onUserFilterLoad = new EventEmitter();

  constructor(
    private formBuilder: FormBuilder,
    private filterRecordService: FilterRecordService,
    private entityService: EntityService,
    private authService: AuthService,
    private billingCloseService: BillingCloseService,
    private filterService: FilterService,
  ) {
    this.form = this.formBuilder.group({
      entities: [[]],
      plans: [[]],
      from: [new Date(), Validators.required],
      to: [new Date(), Validators.required],
      protocol: [""],
      aliquotTaxs: [[]],
      equipments: [null],
      speciality: [null],
      practice: [""],
      services: [[]],
      patient: [null],
      billingStates: [[]],
      noBillingReasons: [[]],
      branchs: [[]],
      onlyDerivantes: [false],
      atLeastOneInformed: [false],
      inSector: [false],
      orderByPatient: [false],
    });

    this.filterCompletePractices = new FilterCompleteService<PracticeFilter>(
      [],
      this.form.controls.practice,
    );
  }

  get f() {
    return this.form.controls;
  }

  get filteredPracticesOptions() {
    return this.filterCompletePractices
      ? this.filterCompletePractices.filteredOptions
      : [];
  }

  async saveFiltersOnServer() {
    await this.filterRecordService.saveFiltersOnServer(
      "BillingCloseFilterComponent",
      this.form,
    );
  }

  async ngOnInit() {
    try {
      try {
        if (
          this.filterRecordService.existsFilters("BillingCloseFilterComponent")
        ) {
          this.filterRecordService.setFilters(
            "BillingCloseFilterComponent",
            this.form,
          );
        } else {
          await this.filterRecordService.loadFiltersFromServer(
            "BillingCloseFilterComponent",
            this.form,
          );
        }
      } catch (err) {
        console.log("No se pudieron cargar los filtros del servidor", err);
      }

      await this.loadEntities();
      await this.loadAliquotTaxs();
      await this.loadEquipments();
      await this.loadSpecialities();
      await this.loadPractices();
      await this.loadServices();
      await this.loadBillingStates();
      await this.laodNoBillingReasons();
      await this.loadBranchs();

      this.form.controls.entities.valueChanges.subscribe(() => {
        this.loadPlans();
      });

      this.form.controls.onlyDerivantes.valueChanges.subscribe(async () => {
        await this.loadEntities();
        this.loadPlans();
      });

      // this.onInitSearch.emit();
    } catch (err) {
      console.log(err);
    } finally {
      this.authService.setFilterBillingClose(true);
    }
  }

  toggleAllEntitySelection() {
    if (this.allEntitySelected.selected) {
      this.form.patchValue({
        entities: [...this.entities, this.allEntitySelected.value],
      });
    } else {
      this.form.patchValue({ entities: [] });
      this.form.patchValue({ plans: [] });
    }
  }

  private async laodNoBillingReasons() {
    this.noBillingReasons = await this.filterService.getNoBillingReasonFilter();
    const filterNoBillingReasons =
      this.filterRecordService.getFilterFromList<NoBillingReasonFilter>(
        "BillingCloseFilterComponent",
        "noBillingReasons",
        this.noBillingReasons,
      );
    this.form.patchValue({
      noBillingReasons: filterNoBillingReasons,
    });
  }

  private async loadBillingStates() {
    this.billingStates = await this.filterService.getBillingStateFilter();
    const filterBillingStates =
      this.filterRecordService.getFilterFromList<BillingStateFilter>(
        "BillingCloseFilterComponent",
        "billingStates",
        this.billingStates,
      );
    this.form.patchValue({
      billingStates: filterBillingStates,
    });
  }

  private async loadServices() {
    this.services = await this.filterService.getServicesFilter();
    const filterServices =
      this.filterRecordService.getFilterFromList<ServiceFilter>(
        "BillingCloseFilterComponent",
        "services",
        this.services,
      );
    this.form.patchValue({
      services: filterServices,
    });
  }

  private async loadEquipments() {
    this.equipments = await this.filterService.getEquipmentsFilter();
  }

  private async loadSpecialities() {
    this.specialities = await this.filterService.getSpecialtiesFilter();
  }

  private async loadPractices() {
    this.filterCompletePractices = new FilterCompleteService<PracticeFilter>(
      await this.filterService.getPracticesFilters(),
      this.form.controls.practice,
    );
  }

  private async loadBranchs() {
    this.branchs = await this.filterService.getCentersFilter();
    const filterBranchs =
      this.filterRecordService.getFilterFromList<ServiceFilter>(
        "BillingCloseFilterComponent",
        "branchs",
        this.branchs,
      );
    this.form.patchValue({
      branchs: filterBranchs,
    });
  }

  private async loadAliquotTaxs() {
    this.aliquotTaxs = (await this.filterService.getAliquotsTax()).filter(
      (a) => a.TaxId == TaxType.Iva,
    );
    const filterAliquotTaxs =
      this.filterRecordService.getFilterFromList<AliquotTax>(
        "BillingCloseFilterComponent",
        "aliquotTaxs",
        this.aliquotTaxs,
      );
    this.form.patchValue({
      aliquotTaxs: filterAliquotTaxs,
    });
  }

  private async loadEntities() {
    const onlyDerivantes = this.form.controls.onlyDerivantes.value
      ? true
      : false;

    if (onlyDerivantes === true && this.entitiesDerivantes.length === 0) {
      this.entitiesDerivantes = await (
        await this.filterService.getEntitiesFilter(false)
      ).filter(
        (e) => !this.entitiesNoDerivantes.some((ende) => ende.Id === e.Id),
      );
    } else if (this.entitiesNoDerivantes.length === 0) {
      this.entitiesNoDerivantes =
        await await this.filterService.getEntitiesFilter(true);
    }

    this.entities = onlyDerivantes
      ? [...this.entitiesDerivantes]
      : [...this.entitiesNoDerivantes];

    const filterEntities = this.filterRecordService.getFilterFromList<Entity>(
      "BillingCloseFilterComponent",
      "entities",
      this.entities,
    );

    this.form.patchValue({
      entities: filterEntities,
    });

    if (filterEntities && filterEntities.length > 0) {
      const ids = filterEntities.map((p) => p.Id);
      this.entityService.getPlansByEntityIds(ids).then((info) => {
        this.plans = info;
        this.form.patchValue({
          plans: this.filterRecordService.getFilterFromList<Plan>(
            "BillingCloseFilterComponent",
            "plans",
            this.plans,
          ),
        });
      });
    }
  }

  private loadPlans() {
    this.form.patchValue({ plans: [] });
    this.plans = [];
    if (this.form.controls.entities.value) {
      const ids = (<Entity[]>this.form.controls.entities.value)
        .filter((p) => p.Id > 0)
        .map((p) => p.Id);
      this.entityService.getPlansByEntityIds(ids).then((info) => {
        this.plans = info;
        this.form.patchValue({ plans: this.plans });
      });
    }
  }

  async saveFilters() {
    this.filterRecordService.saveFilters(
      "BillingCloseFilterComponent",
      this.form,
    );
  }

  setFilters(): boolean {
    return this.filterRecordService.setFilters(
      "BillingCloseFilterComponent",
      this.form,
    );
  }

  getSearchFilters(): SearchFilter[] {
    const requiredTags: string[] = [];
    requiredTags.push("from");
    requiredTags.push("to");
    return this.filterRecordService.convertToSearchFilters(
      this.form,
      requiredTags,
    );
  }

  async search(): Promise<any> {
    this.orderByPatient = this.form.controls.orderByPatient.value
      ? this.form.controls.orderByPatient.value
      : false;

    const items = await this.billingCloseService.getBillingCloseSearchItems(
      this.form.controls.plans.value
        ? (<Plan[]>this.form.controls.plans.value).map((p) => p.Id)
        : null,
      this.form.controls.from.value
        ? <Date>this.form.controls.from.value
        : null,
      this.form.controls.to.value ? <Date>this.form.controls.to.value : null,
      this.form.controls.protocol.value
        ? this.form.controls.protocol.value
        : "",
      this.form.controls.aliquotTaxs.value
        ? (<AliquotTax[]>this.form.controls.aliquotTaxs.value).map((p) => p.Id)
        : null,
      this.form.controls.services.value
        ? (<ServiceFilter[]>this.form.controls.services.value).map((p) => p.Id)
        : null,
      this.form.controls.billingStates.value
        ? (<BillingStateFilter[]>this.form.controls.billingStates.value).map(
            (p) => p.Id,
          )
        : null,
      this.form.controls.noBillingReasons.value
        ? (<NoBillingReasonFilter[]>(
            this.form.controls.noBillingReasons.value
          )).map((p) => p.Id)
        : null,
      this.form.controls.branchs.value
        ? (<Center[]>this.form.controls.branchs.value).map((p) => p.Id)
        : null,
      this.form.controls.patient.value &&
        typeof this.form.controls.patient.value !== "string"
        ? (<PatientSearch>this.form.controls.patient.value).Id
        : null,
      this.form.controls.practice.value &&
        typeof this.form.controls.practice.value !== "string"
        ? (<PracticeFilter>this.form.controls.practice.value).Id
        : null,
      this.form.controls.equipments.value
        ? (<EquipmentFilter>this.form.controls.equipments.value).Id
        : null,
      this.form.controls.speciality.value
        ? (<SpecialityFilter>this.form.controls.speciality.value).Id
        : null,
      this.form.controls.atLeastOneInformed.value
        ? this.form.controls.atLeastOneInformed.value
        : false,
      this.form.controls.orderByPatient.value
        ? this.form.controls.orderByPatient.value
        : false,
      this.authService.seeCloseWithTotals(),
      this.form.controls.inSector.value ? this.authService.getSectorId() : null,
    );

    return items || [];
  }
}
